export default __webpack_public_path__ + "static/media/empty_campaigns.1200c949.png";